// extracted by mini-css-extract-plugin
module.exports = {"page-container":"page_page-container__WVs6J","calculator-container":"page_calculator-container__RbBby","calculator-section":"page_calculator-section__qEZpY"};